import { render, staticRenderFns } from "./AddRoomPrice.vue?vue&type=template&id=1948eca2&scoped=true&"
import script from "./AddRoomPrice.vue?vue&type=script&lang=js&"
export * from "./AddRoomPrice.vue?vue&type=script&lang=js&"
import style0 from "./AddRoomPrice.vue?vue&type=style&index=0&id=1948eca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948eca2",
  null
  
)

export default component.exports